import { render, staticRenderFns } from "./Verka_Question_Mark_Neg.vue?vue&type=template&id=282cdaa0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports